import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// Design system
import './styles/variables.css'
import './styles/element-overrides.css'
import './styles/transitions.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(ElementPlus, { locale: zhCn, size: 'default' })
app.use(router)

app.mount('#app')
